import { action, makeObservable, observable } from 'mobx';
import { ApiVariables } from '../../api/apiSchema';
import { notifyError, notifySuccess } from '../../services/notifications';
import { Message, StoreNode } from '../../store';
import { Store } from '../../store/store';
import { WindowState } from '../overlays';

export class ToggleDeceptioAiWindowState
  extends StoreNode {

  readonly nodeType = 'ToggleDeceptioAiWindow';

  constructor(store: Store) {
    super(store);
    makeObservable(this);
    this.window.listen(
      this.windowListener);
  }

  @observable
  deceptioAiEnabled: boolean = false;

  @observable
  isLoading = false;

  private windowListener = (msg: Message<WindowState>) => {
    switch (msg.type) {
      case 'close':
      case 'outsideClick':
        if (this.isLoading)
          return;
        this.close();
        break;
    }
  }

  @observable teamId: string | null = null;
  readonly window = new WindowState(this.store);

  async submit() {
    this.isLoading = true;

    const vars: ApiVariables<'updateTeam'> = {
      args: {
        teamId: this.teamId || '',
        deceptioAiEnabled: this.deceptioAiEnabled
      }
    };

    const [, err] = await this.store.teamManager.updateTeam(vars);
    if (err) {
      this.emit('error');
      this.handleSubmitReject(`Could not update library. Please try again.`);

      return;
    }

    this.emit('success');
    this.handleSubmitSuccess(`Library updated.`);
  }

  @action
  private handleSubmitReject(msg: string) {
    this.isLoading = false;

    notifyError(this, msg);
  }

  @action
  private handleSubmitSuccess(msg: string) {
    this.isLoading = false;
    this.close();

    notifySuccess(this, msg);
  }

  @action
  open({ teamId, deceptioAiEnabled }: { teamId: string, deceptioAiEnabled: boolean }) {
    this.dispatch('Overlays', 'openWindow', { name: 'ToggleDeceptioAiWindow' });

    this.teamId = teamId ?? null;
    this.deceptioAiEnabled = deceptioAiEnabled;
  }

  @action
  close() {
    this.dispatch('Overlays', 'closeWindow');
    this.emit('close');

    this.teamId = null;
  }
}